import React from "react";
import { BRAND, NAV_LINKS } from "../content";
import { Instagram, Linkedin, Youtube } from "lucide-react";
import { openWhatsApp, buildWhatsAppUrl } from "../lib/whatsapp";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0c021a] border-t border-[#B48DFF]/15 mt-10"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="/brand/logo.png?v=4"
                alt="DietDotIn — Best Dietician in Bangalore"
                className="h-16 w-auto drop-shadow-[0_0_28px_rgba(122,43,255,0.65)]"
              />
            </div>
            <p className="mt-5 text-[#D8CCFF] text-sm leading-relaxed max-w-md font-body">
              Premium nutrition and lifestyle transformation — built on
              science, mindfulness, and the discipline of small daily wins.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { Icon: Instagram, href: "#", label: "Instagram" },
                { Icon: Linkedin, href: "#", label: "LinkedIn" },
                { Icon: Youtube, href: "#", label: "YouTube" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="w-10 h-10 rounded-full glass flex items-center justify-center text-[#CFAEFF] hover:text-white hover:neon-aqua transition-all"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-white font-heading font-semibold mb-4">
              Explore
            </div>
            <ul className="space-y-2 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-[#CFAEFF] hover:text-[#27C6FF] transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-white font-heading font-semibold mb-4">
              Contact
            </div>
            <ul className="space-y-2 text-sm text-[#CFAEFF]">
              <li>
                <a
                  href={buildWhatsAppUrl(BRAND.whatsapp)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    e.preventDefault();
                    openWhatsApp({
                      phone: BRAND.whatsapp,
                      displayNumber: BRAND.whatsappDisplay,
                    });
                  }}
                  className="hover:text-white"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp: {BRAND.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="hover:text-white"
                  data-testid="footer-email"
                >
                  {BRAND.email}
                </a>
              </li>
              <li>{BRAND.city}</li>
            </ul>

            <div className="mt-6 text-xs text-[#9B86C8] leading-relaxed">
              Keywords: Best Dietician in Bangalore · Fat Loss Dietician ·
              Therapeutic Diets · Mental Wellness Coach · Online Diet
              Consultation · Sustainable Weight Loss
            </div>
          </div>
        </div>

        <div className="mt-12">
          <div className="font-display font-extrabold tracking-tight text-[18vw] md:text-[14vw] leading-none bg-gradient-to-b from-[#7A2BFF]/30 to-transparent bg-clip-text text-transparent select-none">
            DIETDOTIN
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#B48DFF]/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#9B86C8]">
          <div>© {new Date().getFullYear()} DietDotIn. All rights reserved.</div>
          <div>Crafted with care for sustainable wellness.</div>
        </div>
      </div>
    </footer>
  );
}
